import { Button, Col, DatePicker, Form, Input, Row, Select } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { getCourseOffers } from '../../../../services/courseOfferService';
const { Option } = Select;

const AlumniSearch = ({ onReset, onFinish, form, initialValues }) => {
  const [filteredCourseOffers, setFilteredCourseOffers] = useState([]);
  const [courseOffers, setCourseOffers] = useState([]);

  useEffect((e) => {
    getCourseOffers()
      .then((response) => {
        const courseList = response.data.paginatedList;
        let data = [];
        courseList.forEach((course) => {
          data.push({
            label: course.code,
            value: course.code,
            description: course.description
          });
        });
        setCourseOffers(data);
      })
      .catch((error) => {
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
      });
  }, []);

  const filterItems = (value, originalData, setter) => {
    const filtered = originalData.filter((item) => {
      const substring = item.label.substr(0, value.length);
      return substring.toLowerCase() === value.toLowerCase();
    });
    setter(filtered);
  };

  const getFilteredCourseOffers = (value) => {
    filterItems(value, courseOffers, setFilteredCourseOffers);
  };

  const courseListOptions = courseOffers.map((course, index) => (
    <Option value={course.label} key={index}>
      {course.label} - {course.description}
    </Option>
  ));

  return (
    <Form form={form} onFinish={onFinish} initialValues={initialValues}>
      <Row gutter={16}>
        <Col span={10}>
          <Form.Item name="code">
            <Select
              placeholder={'Select Course Offer Code'}
              showSearch={true}
              onSearch={getFilteredCourseOffers}>
              {courseListOptions}
            </Select>
          </Form.Item>
        </Col>
        <Col>
          <Form.Item label="Email" name="email">
            <Input />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item
            label="Start Date"
            name="startDate"
            rules={[
              { required: false, message: 'Please input start date!' }
            ]}>
            <DatePicker
              showNow={false}
              style={{ width: '100%' }}
              allowClear
            />
          </Form.Item>
        </Col>

        <Col>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button htmlType="button" onClick={onReset}>
              Reset
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

AlumniSearch.propTypes = {
  onFinish: PropTypes.func,
  onReset: PropTypes.func,
  initialValues: PropTypes.object,
  form: PropTypes.any //change
};

AlumniSearch.defaultProps = {};

export default AlumniSearch;
